import React from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Stack, TextField } from "@mui/material";
import { ownerApi } from "../../../../api/owner";
import { formatApiError } from "../../../../api/client";

export default function OwnerTaskDialog({ open, onClose, onSaved, selectedDate, initialInitiativeId = "" }) {
  const [initiatives, setInitiatives] = React.useState([]);
  const [form, setForm] = React.useState({ title: "", time: "09:00", estimatedMinutes: "30", initiativeId: "", notes: "" });
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    if (!open) return;
    setError("");
    setForm({ title: "", time: "09:00", estimatedMinutes: "30", initiativeId: initialInitiativeId || "", notes: "" });
    ownerApi.listInitiatives({ status: "active", limit: 100 })
      .then((response) => setInitiatives(response?.initiatives || []))
      .catch(() => setInitiatives([]));
  }, [open, initialInitiativeId]);

  const submit = async () => {
    if (!form.title.trim()) { setError("Escribí la tarea."); return; }
    setSaving(true); setError("");
    try {
      const scheduledStartAt = form.time ? new Date(`${selectedDate}T${form.time}:00`).toISOString() : null;
      await ownerApi.createCommitment({
        title: form.title.trim(),
        kind: "task",
        priority: "normal",
        scheduledStartAt,
        estimatedMinutes: form.estimatedMinutes ? Number(form.estimatedMinutes) : null,
        initiativeId: form.initiativeId || null,
        notes: form.notes.trim(),
        work: { state: "ready" },
        source: { kind: "manual" },
      });
      await onSaved?.();
      onClose?.();
    } catch (err) {
      setError(formatApiError(err, "No pude crear la tarea."));
    } finally {
      setSaving(false);
    }
  };

  return <Dialog open={open} onClose={saving ? undefined : onClose} fullWidth maxWidth="xs">
    <DialogTitle sx={{ fontWeight: 1000 }}>Nueva tarea</DialogTitle>
    <DialogContent>
      <Stack spacing={1.2} sx={{ pt: .4 }}>
        {error ? <Alert severity="error">{error}</Alert> : null}
        <TextField autoFocus label="Qué hay que hacer" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
        <Stack direction="row" spacing={1}>
          <TextField fullWidth type="time" label="Hora" InputLabelProps={{ shrink: true }} value={form.time} onChange={(e) => setForm({ ...form, time: e.target.value })} />
          <TextField select fullWidth label="Duración" value={form.estimatedMinutes} onChange={(e) => setForm({ ...form, estimatedMinutes: e.target.value })}>
            <MenuItem value="15">15 min</MenuItem><MenuItem value="30">30 min</MenuItem><MenuItem value="45">45 min</MenuItem><MenuItem value="60">1 h</MenuItem><MenuItem value="90">1 h 30</MenuItem><MenuItem value="120">2 h</MenuItem>
          </TextField>
        </Stack>
        {initiatives.length ? <TextField select label="Proyecto (opcional)" value={form.initiativeId} onChange={(e) => setForm({ ...form, initiativeId: e.target.value })}>
          <MenuItem value="">Sin proyecto</MenuItem>{initiatives.map((row) => <MenuItem key={row.id || row._id} value={row.id || row._id}>{row.name}</MenuItem>)}
        </TextField> : null}
        <TextField label="Nota (opcional)" multiline minRows={2} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
      </Stack>
    </DialogContent>
    <DialogActions><Button onClick={onClose} disabled={saving}>Cancelar</Button><Button variant="contained" onClick={submit} disabled={saving}>{saving ? "Guardando…" : "Crear"}</Button></DialogActions>
  </Dialog>;
}
